
import { cn } from '@/lib/utils';
import { useState, useEffect } from 'react';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center' | 'right';
  className?: string;
  rotatingTexts?: string[];
}

const SectionTitle = ({ 
  title, 
  subtitle, 
  align = 'center',
  className,
  rotatingTexts = []
}: SectionTitleProps) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  
  const alignClasses = {
    left: 'text-right',
    center: 'text-center',
    right: 'text-left'
  };

  useEffect(() => {
    if (rotatingTexts.length <= 1) return;

    const interval = setInterval(() => {
      setIsAnimating(true);
      
      // Change text after exit animation completes
      setTimeout(() => {
        setCurrentTextIndex((prevIndex) => (prevIndex + 1) % rotatingTexts.length);
        setIsAnimating(false);
      }, 500); // 500ms for the exit animation
      
    }, 3000); // Change text every 3 seconds

    return () => clearInterval(interval);
  }, [rotatingTexts.length]);

  return (
    <div className={cn("mb-12", alignClasses[align], className)}>
      <h2 className="text-3xl md:text-4xl font-light mb-4">{title}</h2>
      {subtitle && (
        <p className="text-gray-600 max-w-2xl mx-auto mb-2">{subtitle}</p>
      )}
      
      {rotatingTexts.length > 0 && (
        <div className="h-8 md:h-10 overflow-hidden my-1">
          <p 
            className={cn(
              "text-xl md:text-2xl font-medium text-gray-800 transition-all duration-500 transform",
              isAnimating ? "opacity-0 -translate-y-8" : "opacity-100 translate-y-0"
            )}
          >
            {rotatingTexts[currentTextIndex]}
          </p>
        </div>
      )}
    </div>
  );
};

export default SectionTitle;
